<template>
    <el-pagination
      v-bind="$attrs"
    >
      <slot />
    </el-pagination>
</template>

<script lang="ts">
import {ElPagination} from 'element-plus';
export default {
    name: "TqPagination",
    data() {
        return {

        }
    },
    props: {
        ...ElPagination.props,
        layout: {
            type: String,
            default: 'total, sizes, prev, pager, next, jumper'
        },
        pageSizes: {
            type: Array,
            default () {
                return [20, 50, 100];
            }
        },
    },
    methods: {
    }
}
</script>
